export const filterMenuItems = (originMenus: any, subString: string) => {
  const subStr: string = subString.toLowerCase();
  const filterMenus = (menus: any) => {
    if (menus.length === 0) {
      return [];
    }
    return menus.filter((m: any) => {
      if (m.title.toLowerCase().includes(subStr)) {
        return true;
      }
      if (m.subSubMenus) {
        m.subSubMenus = filterMenus(m.subSubMenus);
        m.open = m.subSubMenus.length > 0;
      } else if (m.subMenus) {
        m.subMenus = filterMenus(m.subMenus);
        m.open = m.subMenus.length > 0;
      }
      if (subString.length === 0) m.open = false;
      return (
        m.title.toLowerCase().includes(subStr) ||
        m.subMenus?.length > 0 ||
        m.subSubMenus?.length > 0
      );
    });
  };
  const clone = JSON.parse(JSON.stringify(originMenus));
  return filterMenus(clone);
};
